<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerAction>
                        <b-button variant="primary" @click="$bvModal.show('addShow')">新增</b-button>
                    </template>
                    <template v-slot:body>
                        <b-row>
                            <b-col md="12" class="table-responsive">
                                <!-- {{ datas.items }} -->
                                <b-table bordered hover :items="datas.items" :fields="columns" :busy="isBusy">
                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                    <template v-slot:cell(role)="data">
                                        <div style="display: flex; color: white; font-size: 12px;">
                                            <div v-if="data.item.role == 0"
                                                style="background-color: #847AEB; padding: 2px 6px; border-radius: 4px;">
                                                管理员
                                            </div>
                                            <div v-if="data.item.role == 1"
                                                style="background-color: #A97CEC; padding: 2px 6px; border-radius: 4px;">
                                                操作员
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:cell(create_at)="data">
                                        {{ formatTimestampCustom(data.item.create_at) }}
                                    </template>
                                    <template v-slot:cell(login_at)="data">
                                        <div v-if="data.item.login_at === 0">
                                            未登录
                                        </div>
                                        <div v-else>
                                            {{ formatTimestampCustom(data.item.login_at) }}
                                        </div>
                                    </template>
                                    <template v-slot:cell(update_at)="data">
                                        {{ formatTimestampCustom(data.item.update_at) }}
                                    </template>
                                    <template v-slot:cell(action)="data">
                                        <div style="display: flex; justify-content: center;">
                                            <div style="margin-left: 6px;">
                                                <b-button variant="primary mr-1 mb-1" size="sm"
                                                    @click="edit(data)">编辑</b-button>
                                            </div>
                                            <div style="margin-left: 6px;">
                                                <b-button variant="primary mr-1 mb-1" size="sm"
                                                    @click="apiKey(data)">APIKEY</b-button>
                                            </div>
                                            <div style="margin-left: 6px;">
                                                <b-button variant="primary mr-1 mb-1" size="sm"
                                                    @click="remove(data)">删除</b-button>
                                            </div>
                                        </div>
                                    </template>
                                </b-table>
                                <div style="display: flex; justify-content: flex-end;">
                                    <b-pagination v-model="page" :total-rows="datas.total" :per-page="perPage"
                                        aria-controls="my-table" @change="getList"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>

        <b-modal id="addShow" title="新增商家" centered hide-footer size="lg">
            <b-form ref="form" @submit="handleAddSubmit">
                <div style="display: flex;">
                    <div style="flex: 1; margin-right: 12px;">
                        <b-form-group label="名称" label-for="name-input">
                            <b-form-input id="name-input" v-model="addForm.name" required></b-form-input>
                        </b-form-group>
                    </div>
                    <div style="flex: 1; margin-right: 12px;">
                        <b-form-group label="用户名" label-for="name-input">
                            <b-form-input id="name-input" v-model="addForm.username" required></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div style="margin: 22px 0;">
                </div>
                <div style="display: flex; justify-content: flex-end;">
                    <b-button type="submit" variant="primary">创建</b-button>
                </div>
            </b-form>
        </b-modal>

        <b-modal id="editShow" title="编辑商家" centered hide-footer size="lg">
            <div>
                <b-form ref="form" @submit="handleEditSubmit">
                    <div style="display: flex;">
                        <div style="flex: 1; margin-right: 12px;">
                            <b-form-group label="名称" label-for="name-input">
                                <b-form-input id="name-input" v-model="editForm.name" required></b-form-input>
                            </b-form-group>
                        </div>
                        <div style="flex: 1; margin-right: 12px;">
                            <b-form-group label="用户名" label-for="name-input">
                                <b-form-input id="name-input" v-model="editForm.username" required></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <div style="flex: 1; margin-right: 12px;">
                            <b-form-group label="密码" label-for="name-input">
                                <b-form-input id="name-input" v-model="editForm.password" required></b-form-input>
                            </b-form-group>
                        </div>
                        <div style="flex: 1; margin-right: 12px;"></div>
                    </div>
                    <div style="display: flex; justify-content: flex-end;">
                        <b-button type="submit" variant="primary">更新</b-button>
                    </div>
                </b-form>
            </div>
        </b-modal>

    </b-container>
</template>
<script>
import { core } from "../../config/pluginInit"
import axiosInstance from '../../services/index'

export default {
    mounted() {
        core.index()

        this.getList()
    },
    data() {
        return {
            columns: [
                { label: "商户号", key: "id", class: "text-left" },
                { label: "商家昵称", key: "name", class: "text-left" },
                { label: "账号", key: "username", class: "text-left" },
                { label: "注册时间", key: "create_at", class: "text-left" },
                { label: "操作", key: "action", class: "text-center" }
            ],
            datas: {},
            addForm: {},
            editForm: {},
            page: 1,
            perPage: 10,
            qrcode_path: '',
            isBusy: false,
        }
    },
    methods: {
        apiKey(e) {
            this.$bvModal.msgBoxConfirm('APIKEY尤为重要，请不要随意发放，点击"好的"后，APIKEY将复制到您的剪切板。', {
                title: '系统消息',
                okVariant: 'success',
                okTitle: '好的',
                cancelTitle: '取消',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        // 使用Clipboard API复制内容
                        navigator.clipboard.writeText(e.item.key).then(function () {
                            // _this.$bvToast.toast('内容已复制到剪切板', {
                            //     title: "提示",
                            //     variant: 'success',
                            //     solid: true
                            // })
                        }).catch(function () {
                            // console.error('复制失败：', err)
                        })
                    }
                })
        },
        logined() {
            this.getList()
            this.$bvModal.hide('qrcodeShow')
        },
        qrcode(e) {
            this.$bvModal.show('qrcodeShow')

            axiosInstance.get(`/api/robot_api/qrcode?id=${e.item.id}`).then((res) => {
                this.qrcode_path = res.data
            })
        },
        edit(e) {
            this.editForm = Object.assign({}, e.item)

            this.$bvModal.show('editShow')
        },
        remove(e) {
            const _this = this
            this.$bvModal.msgBoxConfirm('确定要执行删除操作吗', {
                title: '请确认',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: '删除',
                cancelTitle: '取消',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.isBusy = true
                        axiosInstance.post('/shop/delete', {
                            id: e.item.id,
                        }).then((res) => {
                            // 获取新数据
                            _this.getList()
                        }).catch(() => {
                            // console.error('创建失败:', error)
                        })
                    }
                })
        },
        getList() {
            this.isBusy = true
            axiosInstance.get(`/shop/list?page=${this.page}&perPage=${this.perPage}`).then((res) => {
                this.datas = res.data
                this.isBusy = false
            })
        },
        handleEditSubmit() {
            const _this = this

            // 隐藏弹窗
            _this.$bvModal.hide('editShow')
            // 加载
            _this.isBusy = true

            axiosInstance.post('/shop/update', this.editForm).then((res) => {
                // 清空表单
                _this.editForm = {}
                // 获取新数据
                _this.getList()
            }).catch(() => {
                // console.error('创建失败:', error)
            })

            // 阻止默认的表单提交行为
            event.preventDefault()
        },
        handleAddSubmit() {
            const _this = this

            // 隐藏弹窗
            _this.$bvModal.hide('addShow')
            // 加载
            _this.isBusy = true

            axiosInstance.post('/shop/add', this.addForm).then((res) => {
                // 清空表单
                _this.addForm = {}
                // 获取新数据
                _this.getList()
            }).catch(() => {
                // console.error('创建失败:', error)
            })

            // 阻止默认的表单提交行为
            event.preventDefault()
        },
        formatTimestampCustom(timestamp) {
            const date = new Date(timestamp * 1000)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }

    },
}
</script>

<style>
.modal {
    background-color: rgba(0, 0, 0, 0.3);
}
</style>
